$(function()
{
    const singleItemParallax = $(".single-item-parallax");

    $(window).on("scroll", function()
    {
        const scroll = $(document).scrollTop();

        singleItemParallax.css({
            "background-position": "0% " + (-.4 * scroll) + "px"
        });
    });

    $(window).scroll(function()
    {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
        const offset = 250;
        const duration = 300;

        if (!isDesktop)
        {
            if ($(this).scrollTop() > offset)
            {
                $(".back-to-top").fadeIn(duration);
                $(".back-to-top-center").fadeIn(duration);
            }
            else
            {
                $(".back-to-top").fadeOut(duration);
                $(".back-to-top-center").fadeOut(duration);
            }
        }
    });

    if (!App.isShopBuilder)
    {
        if ($("#titleBeforeBreadcrumbs").length > 0)
        {
            $("[data-component=\"breadcrumbs\"]").each(function()
            {
                $(this).addClass("moved");
                $(this).insertAfter($("#titleBeforeBreadcrumbs"));
            });
        }
        else
        {
            $("[data-component=\"breadcrumbs\"]").each(function()
            {
                $(this).addClass("visible");
            });
        }

        if ($("#mainTopMenuWrapper").attr("data-sticky") === "true")
        {
            // Check the initial Poistion of the Sticky Header
            const stickyHeaderTop = $("#mainTopMenuWrapper").offset().top;

            $(window).scroll(function()
            {
                if ($(window).scrollTop() > stickyHeaderTop && $("#mainTopMenuWrapper").is(":visible"))
                {
                    $("#mainTopMenuWrapper").addClass("sticky");
                }
                else
                {
                    $("#mainTopMenuWrapper").removeClass("sticky");
                    window.dispatchEvent(new Event("resize"));
                }
            });
        }
    }

    $("body").on("click", "[data-pl-collapse]", function()
    {
        const id = $(this).attr("data-pl-collapse");

        if (id)
        {
            const collapseBlock = $("[data-pl-cl=\"" + id + "\"]");
            const icon = $(this).find("i");

            if (icon.length && collapseBlock.length)
            {
                if (collapseBlock.is(":hidden"))
                {
                    icon.removeClass("pl-chevron-down");
                    icon.addClass("pl-chevron-up");
                }
                else
                {
                    icon.removeClass("pl-chevron-up");
                    icon.addClass("pl-chevron-down");
                }
                collapseBlock.slideToggle("slow");
            }
        }
        return false;
    });

    $(".fake-filter-toggle").on("click", function()
    {
        $("body").addClass("menu-is-visible");
        $(".customf-side-bar").addClass("open");

        return false;
    });

    $(".customf-side-bar-close").on("click", function()
    {
        $("body").removeClass("menu-is-visible");
        $(".customf-side-bar").removeClass("open");
    });

    $("body").on("click", ".btn[data-toggle='modal'][href='#login']", function()
    {
        window.ceresStore.dispatch("loadComponent", "login-modal");
    });
});
